/*eslint-disable*/ module.exports = {
  messages: {
    '% Humidity': '% Humidity',
    '- During flowering and shortly after blooming, three treatments after blooming are indicated at intervals of approximately 10-14 days':
      '- During flowering and shortly after blooming, three treatments after blooming are indicated at intervals of approximately 10-14 days',
    '- During the period 2 weeks before flowering, one treatment before flowering and two treatments after blooming are indicated at intervals of 10-14 days.':
      '- During the period 2 weeks before flowering, one treatment before flowering and two treatments after blooming are indicated at intervals of 10-14 days.',
    '- treatment after flowering and then approximately 10-14 days later':
      '- treatment after flowering and then approximately 10-14 days later',
    '10 Temperature': '10 Temperature',
    '3 days': '3 days',
    '31 days': '31 days',
    '7 days': '7 days',
    '<0>High spread risk</0>, Short incubation period of the pathogen (5 days)':
      '<0>High spread risk</0>, Short incubation period of the pathogen (5 days)',
    '<0>Medium spread risk</0>, Average incubation period of the pathogen (8-11 days)':
      '<0>Medium spread risk</0>, Average incubation period of the pathogen (8-11 days)',
    '<0>Recommendation: </0>During the 2-week period before flowering - one treatment before flowering and two treatments after flowering at intervals of 10-14 days. During flowering and shortly after flowering - three treatments after flowering at intervals of 10-14 days.':
      '<0>Recommendation: </0>During the 2-week period before flowering - one treatment before flowering and two treatments after flowering at intervals of 10-14 days. During flowering and shortly after flowering - three treatments after flowering at intervals of 10-14 days.',
    '<0>Recommendation: </0>Regular treatment at intervals of 5-14 days (according to the level of disease pressure, growth intensity, and the pesticide used) until berry softening.':
      '<0>Recommendation: </0>Regular treatment at intervals of 5-14 days (according to the level of disease pressure, growth intensity, and the pesticide used) until berry softening.',
    '<0>Recommendation: </0>Treatment after flowering and additional treatments every 10-14 days.':
      '<0>Recommendation: </0>Treatment after flowering and additional treatments every 10-14 days.',
    '<0>Statistical data</0> are calculated from the time range set for the graph. It is possible to export data from both the graph and the statistical data table <1>(in *.csv, *.xlsx, *.pdf format)</1>.':
      '<0>Statistical data</0> are calculated from the time range set for the graph. It is possible to export data from both the graph and the statistical data table <1>(in *.csv, *.xlsx, *.pdf format)</1>.',
    '<0>Weak spread risk</0>, Long incubation period of the pathogen (15 days)':
      '<0>Weak spread risk</0>, Long incubation period of the pathogen (15 days)',
    'Above the prognostic curve A - <0>calamitous occurrence</0>':
      'Above the prognostic curve A - <0>calamitous occurrence</0>',
    'Accumulated precipitation mm': 'Accumulated precipitation mm',
    Add: 'Add',
    'Add +': 'Add +',
    'Add User': 'Add User',
    'Add a new condition for disease pressure':
      'Add a new condition for disease pressure',
    'Add alarm name!': 'Add alarm name!',
    'Add condition': 'Add condition',
    'Add intervention': 'Add intervention',
    'Add latitude!': 'Add latitude!',
    'Add longitude!': 'Add longitude!',
    'Add new condition': 'Add new condition',
    'Add sensor': 'Add sensor',
    'Add value': 'Add value',
    Alert: 'Alert',
    Alerts: 'Alerts',
    'All data': 'All data',
    'An error occurred. Please contact the web administrator.':
      'An error occurred. Please contact the web administrator.',
    'Area zoom': 'Area zoom',
    'Average for period': 'Average for period',
    'Average temperature (°C)': 'Average temperature (°C)',
    'Average.T': 'Average.T',
    Back: 'Back',
    'Battery voltage': 'Battery voltage',
    'Battery voltage V': 'Battery voltage V',
    'Between curves A and B - <0>sporadic-calamitous occurrence</0>':
      'Between curves A and B - <0>sporadic-calamitous occurrence</0>',
    Botrytis: 'Botrytis',
    Calamitous: 'Calamitous',
    'Calamitous occurrence': 'Calamitous occurrence',
    Cancel: 'Cancel',
    'Change password': 'Change password',
    'Change to bar chart': 'Change to bar chart',
    'Change to line chart': 'Change to line chart',
    Coding: 'Coding',
    'Condition title': 'Condition title',
    Conditions: 'Conditions',
    'Confirm Password': 'Confirm Password',
    'Confirm new password': 'Confirm new password',
    'Contact information': 'Contact information',
    'Contact information can be set in the basic account settings. The phone number needs to be entered in international format (prefix +421).':
      'Contact information can be set in the basic account settings. The phone number needs to be entered in international format (prefix +421).',
    'Contains <0>all data</0> measured by the station at 10-minute intervals. The data can be filtered temporally and then exported in <1>(in *.csv, *.xlsx, *.pdf format)</1>.':
      'Contains <0>all data</0> measured by the station at 10-minute intervals. The data can be filtered temporally and then exported in <1>(in *.csv, *.xlsx, *.pdf format)</1>.',
    'Contains <0>current data</0> (temperature, pressure, etc.), data collection interval is 10 minutes.':
      'Contains <0>current data</0> (temperature, pressure, etc.), data collection interval is 10 minutes.',
    'Cumulative precipitation in mm': 'Cumulative precipitation in mm',
    'Cumulative precipitation in the last 24 hours':
      'Cumulative precipitation in the last 24 hours',
    'Cumulative precipitation mm': 'Cumulative precipitation mm',
    'Current cumulative precipitation': 'Current cumulative precipitation',
    'Current data': 'Current data',
    'Current humidity': 'Current humidity',
    'Current irradiation': 'Current irradiation',
    'Current pressure': 'Current pressure',
    'Current state': 'Current state',
    'Current status:': 'Current status:',
    'Current status: Outside of the monitored period':
      'Current status: Outside of the monitored period',
    'Current temperature': 'Current temperature',
    'Current value': 'Current value',
    'Daily conditions': 'Daily conditions',
    'Daily precipitation (mm)': 'Daily precipitation (mm)',
    Dancing: 'Dancing',
    Dashboard: 'Dashboard',
    Data: 'Data',
    'Data from table (.csv)': 'Data from table (.csv)',
    'Data from table (.pdf)': 'Data from table (.pdf)',
    'Data from table (.xlsx)': 'Data from table (.xlsx)',
    'Data from the graph (.csv)': 'Data from the graph (.csv)',
    Date: 'Date',
    'Default value': 'Default value',
    Delete: 'Delete',
    Disease: 'Disease',
    'Disease pressure': 'Disease pressure',
    'Downy mildew': 'Downy mildew',
    'Downy mildew - Goidanich': 'Downy mildew - Goidanich',
    'Downy mildew - Šteberly': 'Downy mildew - Šteberly',
    'Downy mildew 2': 'Downy mildew 2',
    'Downy mildew': 'Downy mildew',
    'Downy mildew 2': 'Downy mildew 2',
    Dry: 'Dry',
    E: 'E',
    ERROR: 'ERROR',
    Email: 'Email',
    'Enter a username!': 'Enter a username!',
    'Enter the product': 'Enter the product',
    'Enter the protection period': 'Enter the protection period',
    'Enter the protective period': 'Enter the protective period',
    'Enter weather station name!': 'Enter weather station name!',
    'Enter your email address!': 'Enter your email address!',
    'Enter your name!': 'Enter your name!',
    'Enter your surname!': 'Enter your surname!',
    Error: 'Error',
    'Evaluation of the infection risk is based on calculating the disease pressure index and comparing it with its theoretical model. If the current date falls within the monitored period, the value of the disease pressure index and recommendations for interventions based on the model will be displayed.':
      'Evaluation of the infection risk is based on calculating the disease pressure index and comparing it with its theoretical model. If the current date falls within the monitored period, the value of the disease pressure index and recommendations for interventions based on the model will be displayed.',
    Events: 'Events',
    Export: 'Export',
    'Extended treatment interval (12-14 days)':
      'Extended treatment interval (12-14 days)',
    'Failed to save changes': 'Failed to save changes',
    Favorites: 'Favorites',
    Female: 'Female',
    Files: 'Files',
    Filter: 'Filter',
    Firstname: 'Firstname',
    'For calculating the disease pressure index, the Kasta method model is utilized. The graph displays the measured value of the disease pressure index along with two boundary curves indicating the boundary between weak, moderately strong, and strong disease pressure.':
      'For calculating the disease pressure index, the Kasta method model is utilized. The graph displays the measured value of the disease pressure index along with two boundary curves indicating the boundary between weak, moderately strong, and strong disease pressure.',
    "For evaluating disease pressure, the Šteberly's model is utilized. It evaluates the total rainfall each day from the beginning of May (1st May). The methodology is valid from 15th May until the end of August. The current value is compared to the tabulated values for the specific day. The graph displays <0>3 curves:</0>":
      "For evaluating disease pressure, the Šteberly's model is utilized. It evaluates the total rainfall each day from the beginning of May (1st May). The methodology is valid from 15th May until the end of August. The current value is compared to the tabulated values for the specific day. The graph displays <0>3 curves:</0>",
    Forecast: 'Forecast',
    'Forgot your password?': 'Forgot your password?',
    Fulfilled: 'Fulfilled',
    'Fulfilled 1-day': 'Fulfilled 1-day',
    'Fulfilled 2-day': 'Fulfilled 2-day',
    Gender: 'Gender',
    Graph: 'Graph',
    'Graph data (.pdf)': 'Graph data (.pdf)',
    'Graph data (.xlsx)': 'Graph data (.xlsx)',
    'Hello, dashboard!': 'Hello, dashboard!',
    High: 'High',
    'High danger of Botrytis cinerea infection':
      'High danger of Botrytis cinerea infection',
    'High risk threshold': 'High risk threshold',
    Hobbies: 'Hobbies',
    'Hours with temperature 21 °C < t < 30 °C':
      'Hours with temperature 21 °C < t < 30 °C',
    'Hours with temperature t > 35 °C': 'Hours with temperature t > 35 °C',
    'Hovering over the name of the quantity displays a graph with data for the last 24 hours.':
      'Hovering over the name of the quantity displays a graph with data for the last 24 hours.',
    Humidity: 'Humidity',
    'Humidity %': 'Humidity %',
    'Humidity [%]': 'Humidity [%]',
    'Incorrect code! Please check your email!':
      'Incorrect code! Please check your email!',
    'Incorrect email or password': 'Incorrect email or password',
    'Index value': 'Index value',
    Info: 'Info',
    Intervention: 'Intervention',
    'Intervention table': 'Intervention table',
    Interventions: 'Interventions',
    Irradiation: 'Irradiation',
    'Irradiation W/m2': 'Irradiation W/m2',
    'Last 24 Hours': 'Last 24 Hours',
    'Last 24 hours': 'Last 24 hours',
    'Last 24 hrs': 'Last 24 hrs',
    Lastname: 'Lastname',
    Latitude: 'Latitude',
    'Leaf humidity': 'Leaf humidity',
    'Leaf moisture': 'Leaf moisture',
    'Leaf relative humidity %': 'Leaf relative humidity %',
    'Leaf temperature': 'Leaf temperature',
    'Leaf temperature °C': 'Leaf temperature °C',
    'List of individual stations. Each station collects and contains data divided into the following categories:':
      'List of individual stations. Each station collects and contains data divided into the following categories:',
    'Location settings': 'Location settings',
    'Log in': 'Log in',
    'Log out <0/>': 'Log out <0/>',
    Longitude: 'Longitude',
    Low: 'Low',
    'Low danger of Botrytis cinerea infection':
      'Low danger of Botrytis cinerea infection',
    'Low risk threshold': 'Low risk threshold',
    Male: 'Male',
    Manuals: 'Manuals',
    Map: 'Map',
    'Max.': 'Max.',
    'Max. recorded': 'Max. recorded',
    'Max.T': 'Max.T',
    'Maximal temperature': 'Maximal temperature',
    'Maximum wind gust': 'Maximum wind gust',
    'Maximum wind gust in 10 min m/s': 'Maximum wind gust in 10 min m/s',
    'Maximum wind gust in the last 10 minutes':
      'Maximum wind gust in the last 10 minutes',
    'Measured data': 'Measured data',
    'Measurement time': 'Measurement time',
    Medium: 'Medium',
    'Medium danger of Botrytis cinerea infection':
      'Medium danger of Botrytis cinerea infection',
    'Medium risk threshold': 'Medium risk threshold',
    Method: 'Method',
    'Min.': 'Min.',
    'Min. recorded': 'Min. recorded',
    'Min. temperature (°C)': 'Min. temperature (°C)',
    'Min.T': 'Min.T',
    'Minimal temperature': 'Minimal temperature',
    'Missing depth value': 'Missing depth value',
    'Model by Broom': 'Model by Broom',
    'Model by Goidanich': 'Model by Goidanich',
    'Model by Kast': 'Model by Kast',
    'Model by Šteberly': 'Model by Šteberly',
    'Moderate risk threshold': 'Moderate risk threshold',
    N: 'N',
    NE: 'NE',
    NW: 'NW',
    Name: 'Name',
    'Network error, please try again.': 'Network error, please try again.',
    'New intervention': 'New intervention',
    'New password': 'New password',
    'New settings have been successfully saved':
      'New settings have been successfully saved',
    'No danger of Botrytis cinerea infection':
      'No danger of Botrytis cinerea infection',
    'No data available for the last 24 hours':
      'No data available for the last 24 hours',
    'No disease pressure': 'No disease pressure',
    'No infection': 'No infection',
    None: 'None',
    'Not monitored': 'Not monitored',
    Notificaiton: 'Notificaiton',
    Notifications: 'Notifications',
    Now: 'Now',
    'Number of days': 'Number of days',
    OK: 'OK',
    Occurrence: 'Occurrence',
    'One-day conditions:': 'One-day conditions:',
    'One-time': 'One-time',
    Operator: 'Operator',
    Others: 'Others',
    'Outside of the monitored period': 'Outside of the monitored period',
    Overview: 'Overview',
    'Overview of meteorological station locations. Hovering over the icons will display the names of individual weather stations.':
      'Overview of meteorological station locations. Hovering over the icons will display the names of individual weather stations.',
    Password: 'Password',
    'Password change successful': 'Password change successful',
    'Passwords do not match!': 'Passwords do not match!',
    'Pathogen status': 'Pathogen status',
    'Period (h)': 'Period (h)',
    'Period [h]': 'Period [h]',
    'Phone number': 'Phone number',
    'Please Enter your email': 'Please Enter your email',
    'Please Enter your username': 'Please Enter your username',
    'Please Fill the User Form': 'Please Fill the User Form',
    'Please confirm your password!': 'Please confirm your password!',
    'Please fill in your email!': 'Please fill in your email!',
    'Please fill in your new password!': 'Please fill in your new password!',
    'Please fill in your password!': 'Please fill in your password!',
    'Please fill in your unique code!': 'Please fill in your unique code!',
    'Please input your E-mail!': 'Please input your E-mail!',
    'Please input your correct email': 'Please input your correct email',
    'Please input your name': 'Please input your name',
    'Please select station!': 'Please select station!',
    'Please select you hobbies': 'Please select you hobbies',
    'Please select your gender': 'Please select your gender',
    'Please select your hobbies': 'Please select your hobbies',
    'Powdery mildew': 'Powdery mildew',
    'Powdery mildew': 'Powdery mildew',
    Precipitation: 'Precipitation',
    'Precipitation in the last 10 minutes':
      'Precipitation in the last 10 minutes',
    'Precipitation in the last 24 hours': 'Precipitation in the last 24 hours',
    'Precipitation in the last 3 days': 'Precipitation in the last 3 days',
    'Precipitation in the last 30 days': 'Precipitation in the last 30 days',
    'Precipitation in the last 365 days': 'Precipitation in the last 365 days',
    'Precipitation mm': 'Precipitation mm',
    Present: 'Present',
    Pressure: 'Pressure',
    'Pressure [hPa]': 'Pressure [hPa]',
    'Pressure hPa': 'Pressure hPa',
    Product: 'Product',
    'Rain gauge resolution in mm': 'Rain gauge resolution in mm',
    'Rain gauge settings': 'Rain gauge settings',
    'Rain in last 24h': 'Rain in last 24h',
    'Rain in last 4h': 'Rain in last 4h',
    Reading: 'Reading',
    'Recommendation:': 'Recommendation:',
    Refresh: 'Refresh',
    'Regular treatment at intervals of 5-14 days (depending on the level of disease pressure, growth intensity, and the type of preparation) until the berries soften.':
      'Regular treatment at intervals of 5-14 days (depending on the level of disease pressure, growth intensity, and the type of preparation) until the berries soften.',
    Remove: 'Remove',
    'Reproductive interval 15 days': 'Reproductive interval 15 days',
    'Reproductive interval 5 days': 'Reproductive interval 5 days',
    'Reset password': 'Reset password',
    Review: 'Review',
    Risk: 'Risk',
    S: 'S',
    SE: 'SE',
    SW: 'SW',
    Save: 'Save',
    'Save as image': 'Save as image',
    'Save changes': 'Save changes',
    'Save settings': 'Save settings',
    'Search to Select': 'Search to Select',
    'Select a year': 'Select a year',
    'Select disease': 'Select disease',
    'Select disease pressure!': 'Select disease pressure!',
    'Select notification method!': 'Select notification method!',
    'Select operator!': 'Select operator!',
    'Select the date': 'Select the date',
    'Select the weather station!': 'Select the weather station!',
    'Select the year': 'Select the year',
    'Select time period!': 'Select time period!',
    'Select units!': 'Select units!',
    'Select year': 'Select year',
    Sensors: 'Sensors',
    'Setting up alerts for meeting the configured condition (e.g., humidity exceeding 50% for 4 hours). With the "Add" function, we can set alert parameters such as name, monitored weather stations, measured variable, time range, and alert delivery method. By default (without filling in the column), the method is set to alert in the weather portal (record in the "Events" section), but it is also possible to send alerts via email or SMS.':
      'Setting up alerts for meeting the configured condition (e.g., humidity exceeding 50% for 4 hours). With the "Add" function, we can set alert parameters such as name, monitored weather stations, measured variable, time range, and alert delivery method. By default (without filling in the column), the method is set to alert in the weather portal (record in the "Events" section), but it is also possible to send alerts via email or SMS.',
    Settings: 'Settings',
    'Settings <0/>': 'Settings <0/>',
    'Shortened treatment interval (5-7 days)':
      'Shortened treatment interval (5-7 days)',
    'Sign Up': 'Sign Up',
    Singing: 'Singing',
    'Soil moisture at depth ${0} kPa': [
      'Soil moisture at depth $',
      ['0'],
      ' kPa',
    ],
    'Soil moisture at depth {0}': ['Soil moisture at depth ', ['0']],
    'Soil moisture at depth {0} kPa': [
      'Soil moisture at depth ',
      ['0'],
      ' kPa',
    ],
    'Soil sensor': 'Soil sensor',
    'Soil sensor options': 'Soil sensor options',
    'Soil temperature at depth ${0} °C': [
      'Soil temperature at depth $',
      ['0'],
      ' °C',
    ],
    'Soil temperature at depth {0}': ['Soil temperature at depth ', ['0']],
    'Soil temperature at depth {0} °C': [
      'Soil temperature at depth ',
      ['0'],
      ' °C',
    ],
    'Solar radiation W/m2': 'Solar radiation W/m2',
    'Something went wrong!': 'Something went wrong!',
    'Spor. Calamitous': 'Spor. Calamitous',
    'Sporadic-calamitous occurrence': 'Sporadic-calamitous occurrence',
    'Standard treatment interval (8-11 days)':
      'Standard treatment interval (8-11 days)',
    Stations: 'Stations',
    'Statistical data': 'Statistical data',
    'Stay logged in': 'Stay logged in',
    'Strongest wind gust in the last 10 minutes m/s':
      'Strongest wind gust in the last 10 minutes m/s',
    'Strongest wind gust m/s': 'Strongest wind gust m/s',
    Submit: 'Submit',
    'Sum for period': 'Sum for period',
    Summary: 'Summary',
    "Summary of all disease pressures and intervention history for the entire season. The list is filterable and editable. It's important to have the option to add intervention records <0>(displaying the protective period in the list)</0>.":
      "Summary of all disease pressures and intervention history for the entire season. The list is filterable and editable. It's important to have the option to add intervention records <0>(displaying the protective period in the list)</0>.",
    'Sunlight W/m2': 'Sunlight W/m2',
    Surname: 'Surname',
    'Table data (.csv)': 'Table data (.csv)',
    'Table data (.pdf)': 'Table data (.pdf)',
    'Table data (.xlsx)': 'Table data (.xlsx)',
    Temperature: 'Temperature',
    'Temperature [°C]': 'Temperature [°C]',
    'Temperature °C': 'Temperature °C',
    'The <0>graph</0> of quantities over time can be edited in multiple ways. Tools in the top right corner are used for changing the graphical representation of the graph, refreshing, displaying, and exporting <1>(in *.png format)</1>.':
      'The <0>graph</0> of quantities over time can be edited in multiple ways. Tools in the top right corner are used for changing the graphical representation of the graph, refreshing, displaying, and exporting <1>(in *.png format)</1>.',
    'The compass rose represents the current direction and speed of the wind.':
      'The compass rose represents the current direction and speed of the wind.',
    'The condition could not be deleted': 'The condition could not be deleted',
    'The description of the method is provided at the top of the page (Goidanich model), where we monitor the fulfillment of the one-day and two-day infection conditions.':
      'The description of the method is provided at the top of the page (Goidanich model), where we monitor the fulfillment of the one-day and two-day infection conditions.',
    'The index is functional from berry softening.':
      'The index is functional from berry softening.',
    'The input is not valid E-mail!': 'The input is not valid E-mail!',
    'The selection of displayed quantity and time interval can be edited in the section below the graph.':
      'The selection of displayed quantity and time interval can be edited in the section below the graph.',
    'The two passwords that you entered do not match!':
      'The two passwords that you entered do not match!',
    'The user with the given email does not exist':
      'The user with the given email does not exist',
    'Threshold for calamitous occurrence':
      'Threshold for calamitous occurrence',
    'Threshold for sporadic-calamitous occurrence':
      'Threshold for sporadic-calamitous occurrence',
    Time: 'Time',
    Today: 'Today',
    'Total precipitation [mm]': 'Total precipitation [mm]',
    'Tracked diseases and their models for predicting disease pressure:':
      'Tracked diseases and their models for predicting disease pressure:',
    'Two-day conditions': 'Two-day conditions',
    'Two-day conditions:': 'Two-day conditions:',
    'Two-day precipitation (mm)': 'Two-day precipitation (mm)',
    'Under curve B - <0>non-calamitous occurrence</0>':
      'Under curve B - <0>non-calamitous occurrence</0>',
    Unfulfilled: 'Unfulfilled',
    'Unique code': 'Unique code',
    Unit: 'Unit',
    'User List': 'User List',
    'User name': 'User name',
    'User settings': 'User settings',
    UserName: 'UserName',
    Username: 'Username',
    Users: 'Users',
    'Using the Broom model, we evaluate the measured disease pressure. The result is an assessment of the risk.':
      'Using the Broom model, we evaluate the measured disease pressure. The result is an assessment of the risk.',
    'V Voltage of the battery': 'V Voltage of the battery',
    Value: 'Value',
    W: 'W',
    'W/m2 Irradiation': 'W/m2 Irradiation',
    'Weather forecast': 'Weather forecast',
    'Weather station': 'Weather station',
    'Weather station name': 'Weather station name',
    'Weather stations': 'Weather stations',
    'Weather variables': 'Weather variables',
    Wet: 'Wet',
    'Wind direction °': 'Wind direction °',
    'Wind gust direction °': 'Wind gust direction °',
    'Wind speed': 'Wind speed',
    'Wind speed m/s': 'Wind speed m/s',
    'Without infection': 'Without infection',
    'Without occurrence': 'Without occurrence',
    Writing: 'Writing',
    Yesterday: 'Yesterday',
    "You can change the station's location by dragging the pin on the map or by entering coordinates.":
      "You can change the station's location by dragging the pin on the map or by entering coordinates.",
    'avg. T': 'avg. T',
    'max. T': 'max. T',
    'max. T in last 4h': 'max. T in last 4h',
    'min. T': 'min. T',
    'min. T in last 24h': 'min. T in last 24h',
    'mm Cumulative rainfall in the last 24 hours':
      'mm Cumulative rainfall in the last 24 hours',
    station1: 'station1',
    station2: 'station2',
    '°C  Temperature': '°C  Temperature',
  },
};
